import { render, staticRenderFns } from "./EventTicket.vue?vue&type=template&id=c195aa3a&scoped=true"
import script from "./EventTicket.vue?vue&type=script&lang=js"
export * from "./EventTicket.vue?vue&type=script&lang=js"
import style0 from "./EventTicket.vue?vue&type=style&index=0&id=c195aa3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c195aa3a",
  null
  
)

export default component.exports